/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export * from './api';
export * from './configuration';
export * from './models';
